export enum BeneficiaryDesignationStatus {
    UPLOADED = 'I have a beneficiary designation for this employee and uploaded it above',
    SEND_IT_LATER = 'I have a beneficiary designation for this employee and will send it to Principal later',
    THIRD_PARTY = 'A third party has a beneficiary designation for this employee and Principal can reach out to them to retrieve it',
    NO_DESIGNATION = 'I have no beneficiary designation for this employee'
}